import {Component, Input} from '@angular/core';

//Composant simple libellé
@Component (
{
  selector: 'val-simple-libelle',
  imports: 
  [
  ],
  templateUrl: './simple-libelle.component.html',
  styleUrl: './simple-libelle.component.scss'
})
export class SimpleLibelleComponent 
{
  //Libellé
  @Input ()
  public libelle!: string;
}
